module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/common/icon_info-683738b03871b2ce1ca0b82e0d5ac487.svg";